import { render } from "./MyBookItem.vue?vue&type=template&id=715178a4&scoped=true"
import script from "./MyBookItem.vue?vue&type=script&lang=js"
export * from "./MyBookItem.vue?vue&type=script&lang=js"

import "./MyBookItem.vue?vue&type=style&index=0&id=715178a4&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-715178a4"]])

export default __exports__